<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="类型名称:" prop="type">
        <el-input v-model="form.type"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" size="small" @click="onSubmit('form')">{{
          editID == 0 ? "添加" : "修改"
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    editID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: { type: "" },
      rules: {
        type: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error("添加失败");
          return false;
        }
        if (this.editID > 0) {
          const { data: res } = await this.$axios.post(
            "/type/editType",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        } else {
          const { data: res } = await this.$axios.post(
            "type/addtype",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        }
      });
    },
    async getType(id) {
      const { data: res } = await this.$axios.post("/type/getTypeId", {
        id: id,
      });
      console.log(res);
      this.form = res.data;
    },
  },
  created() {
    if (this.editID > 0) {
      console.log(this.editID);
      this.getType(this.editID);
    }
  },
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/articleType/addType.vue